
import filters from "@/filters";
import { Component, Vue } from "vue-property-decorator";
import { Action, State } from "vuex-class";
import AppLayout from "@/layouts/AppLayout.vue";
import { AxiosResponse } from "axios";
import moment from "moment";
import $ from "jquery";
import Loading from "@/components/Loading.vue";

@Component({
  components: {
    Loading,
    AppLayout,
  },
  filters,
})
export default class NotFound extends Vue {
  @Action("getAdminJobFairDetail", { namespace: "admin" })
  private getAdminJobFairDetail: any;

  @State("locale")
  private locale!: string;

  private jobFair: any = null;
  private interval: any = null;
  private seconds = 15;
  private isLoadingJobFair = false;

  private get isEn() {
    return this.locale === "en";
  }
  private get isWithJobFair() {
    return this.$route.name === "not-found-with-job-fair";
  }

  private get isOneDay() {
    return moment(this.jobFair?.start_date).isSame(
      this.jobFair?.end_date,
      "day"
    );
  }

  private created() {
    this.getData();

    if (this.isWithJobFair)
      this.interval = setInterval(() => {
        this.seconds--;
        if (this.seconds === 0) this.goHome();
      }, 1000);
  }

  private beforeDestroy() {
    clearInterval(this.interval);
  }

  private getData() {
    if (this.$route.params.slug) {
      this.isLoadingJobFair = true;
      this.getAdminJobFairDetail({
        params: {
          slug: this.$route.params.slug,
        },
        success: (response: AxiosResponse) => {
          this.jobFair = response.data.data;
          setTimeout(() => {
            $("html, body").animate(
              { scrollTop: ($("#unauthenticated") as any).offset().top - 90 },
              500
            );
          }, 300);
        },
        finally: () => {
          this.isLoadingJobFair = false;
        },
      });
    }
  }

  private goHome(query = {}) {
    this.$router.push({
      name: "job-fair-detail",
      params: {
        slug: this.$route.params.slug,
      },
      query,
    });
  }
}
